import { PipelineStatusBadge } from '@optools/components/pipelines/pipeline-status-badge';
import { Card } from '@optools/components/ui/card';
import { Tooltip, TooltipContent, TooltipTrigger } from '@optools/components/ui/tooltip';
import {
  PipelineStatus,
  RegionalMediaPipeline,
} from '@optools/services/operator-gateway/types/generated/graphql';
import { Info, Server } from 'lucide-react';

import { PipelineControlButton } from '../pipeline-control-button';

export interface RegionalPipelineControlsProps {
  gamePk: number;
  mediaId: string;
  regionalPipelines: RegionalMediaPipeline[];
}

export function RegionalPipelineControls({
  gamePk,
  mediaId,
  regionalPipelines,
}: RegionalPipelineControlsProps) {
  return (
    <Card className="flex flex-col items-start gap-2 p-4">
      <div className="flex items-center gap-2">
        <div className="rounded border border-accent-foreground/70 p-1">
          <Server className="size-4" />
        </div>
        <h1 className="font-bold">Regional Pipeline Controls</h1>
      </div>
      <div className="flex flex-col items-start gap-2">
        {regionalPipelines.map(({ id, region, status }) => {
          return (
            <div
              key={id}
              className="flex items-center gap-6 p-1"
              data-testid={`${id}-pipeline-controls`}>
              <h3 className="w-12 text-xs font-semibold">{region}</h3>
              {status &&
              ![
                PipelineStatus.ARCHIVED,
                PipelineStatus.ERROR,
                PipelineStatus.PENDING,
                PipelineStatus.WARNING,
              ].includes(status) ? (
                <PipelineControlButton
                  gamePk={gamePk}
                  mediaId={mediaId}
                  navigateOnDeprovision={regionalPipelines.length === 1}
                  pipelineId={id}
                  region={region}
                  status={status}
                />
              ) : (
                <div className="flex items-center gap-2">
                  <PipelineStatusBadge status={status} />
                  <Tooltip>
                    <TooltipTrigger>
                      <Info className="size-4" role="presentation" />
                    </TooltipTrigger>
                    <TooltipContent align="start" className="mb-1 p-2 text-xs">
                      <p className="text-xs font-medium">
                        <span className="font-bold">{`${status}`}</span> status prevents pipeline
                        actions
                      </p>
                    </TooltipContent>
                  </Tooltip>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </Card>
  );
}
